import { useHistory } from "react-router-dom";
import { ITableQueryData } from "types/frontend_models/table/ITableQueryData";
import { useMemo, useCallback } from "react";
import { tableQueryToSearch, searchToTableQuery, searchToParams } from "functions/url/URLFunctions";
import { isNullOrEmpty } from "functions/extensions/StringExtensions";


export function useSearchParams()
{
	const history = useHistory();

	const searchParams = useMemo(() =>
	{
		console.log('search', history.location.search);
		if (isNullOrEmpty(history.location.search)) return [];
		return searchToParams(history.location.search);
	}
		, [history]);

	return { searchParams };
}

/** 
 * Used for building and retrieving table queries from the search params in the url 
 * @param ignorePagesizeOptions Ignore the default available page options, which makes high or low values possible
 * */
export function useSearchTableQuery(ignorePagesizeOptions = false)
{
	const history = useHistory();

	const updateSearchByTableQuery = useCallback((tableQuery: ITableQueryData) =>
	{
		let newUrl = history.location.pathname;
		let search = tableQueryToSearch(tableQuery);
		if (search) {
			search = encodeURI(search);
			newUrl += '?' + search;
		} else if (history.location.search) {
			newUrl += '?' + history.location.search;
		}
		if (history.location.hash) newUrl += '#' + history.location.hash;
		history.replace(newUrl);
	}, [history]);

	const getTableQueryFromSearch = useCallback((previousQuery?: ITableQueryData): ITableQueryData =>
	{
		// If search is empty, return no query data 
		if (history.location.search === '') return {};

		const search = decodeURI(history.location.search);
		const query = searchToTableQuery(search, previousQuery, ignorePagesizeOptions);
		return query;
	}, [history, ignorePagesizeOptions]);

	return { updateSearchByTableQuery, getTableQueryFromSearch };
}